
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';

import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
// Action Object for ArtistsCatalog. Import the types from artists/types.js and Invoke Actions from the Vuex Host Components.
import router from '../../../../router';

import { statementServices } from '../../services/statements/statements.service';
import { type } from 'ramda';
import { keyValuesToObj } from '../../../../utility/fp';
import { EOL_REACHED } from '../../../../dt-plugins/advanced-search/load.model';
import { recoupableService } from '../../services/recoupable-service';

const NavTabModule = getNavTabModule(types.StatementDetails, 'statementDetails');


export const recoupableActions = {
  async [types.RecoupableData.FETCH.ALL]({ commit, getters, dispatch ,rootGetters }, payload) {

     const believe_special=rootGetters.account.believe_special

     const resData=await recoupableService.recoupablesTab();

     console.log("resData" ,resData)

     commit(types.RecoupableData.SET.ALL,resData.data);
     
      
      
    },


    async [types.RecoupableList.FETCH.ALL]({ commit, getters, dispatch ,rootGetters }, payload) {

      const believe_special=rootGetters.account.believe_special
 
      const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


      let res;
      console.log("::::",start,"PAYLOAD",payload);
      
      if (searchMode == 'none') {
        // if (start == 0) {
        //   res = await HttpClient.mergeRequests([
        //     statementServices.home(),
        //     statementServices.royaltyStatementsTab(),
          
        //   ]);
        //   commit(types.StatementList.SET.ALL,  res );  // <-- Directly Set the Data. Depends on your particular Logic
        // } else {                // <-- Pagination Logic
        //   res = await statementServices.royaltyStatementPage(start);               // <-- Pagination Logic
          
        //   console.log("res",res)
        
        //   commit(types.StatementList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
        //     ...getters.statementList,
        //     statements: [
        //       ...getters.statementList.statements,
        //       ...res.data.statements, // <-- append new Fetched List
        //     ]
        //   });
  
        //   // Setting EOL
        //   // if (!(res?.data?.length <= 0)) {
        //   //   return EOL_REACHED;
        //   // }
        // }
  
      }else if (searchMode == 'basic') {
        const {   searchString , start_date , end_date,label_id,royalty_account_id,cost_group,royalty_period,status ,release_id,invoice_id} = basicFilter;
    

        if (start == 0) {
          res = await recoupableService.filterCostsV2({...basicFilter});
          console.log("res",res)
          commit(types.RecoupableList.SET.ALL, res.data);
          
          //commit(types.RecoupableList.SET.ALL, res.data);// <-- Set the Data. Here the actual List is nested. Depends on your particular case
  
        }else{
          res = await recoupableService.filterCostsV2({...basicFilter ,start:start});
          console.log("res",res)
          commit(types.RecoupableList.SET.ALL,                {
            ...getters.recoupableList,
            cost_splits:[...getters.recoupableList.cost_splits,...res.data.cost_splits]

          });
        } 
        // if (start == 0) {
        //   commit(types.RecoupableList.SET.ALL, res.data);// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          
          
        // } 
        // else {                // <-- Pagination Logic
        //   commit(types.TrackList.SET.ALL, {               // <-- Pagination Logic
        //     ...getters.trackList,
        //     tracks: [
        //       ...getters.trackList.tracks,
        //       ...res.data // <-- append new Fetched List
        //     ]
        //   });
        // }
    
    
        // Setting EOL
        // if (!(res?.data?.length > 0)) {
        //   return EOL_REACHED;
        // }
      } else if (searchMode == 'advanced') {
        // console.log({ "searchFilter": searchFilter });
        if (start == 0) {
          res = await recoupableService.filterCostsV2({...basicFilter,...searchFilter });
          console.log("res",res)
          commit(types.RecoupableList.SET.ALL, res.data);
          
          //commit(types.RecoupableList.SET.ALL, res.data);// <-- Set the Data. Here the actual List is nested. Depends on your particular case
  
        }else{
          res = await recoupableService.filterCostsV2({...basicFilter,...searchFilter ,start:start});
          console.log("res",res)
          commit(types.RecoupableList.SET.ALL, 
                {
                  ...getters.recoupableList,
                  cost_splits:[...getters.recoupableList.cost_splits,...res.data.cost_splits]

          });
        } 
        // res = await recoupableService.filterCostsV2({...searchFilter,...basicFilter});;
        // console.log("ADVANCE SEARCH DATA",res.data);
        // commit(types.RecoupableList.SET.ALL, res.data);
        // if (start == 0) {
        //   commit(types.LicencesList.SET.ALL, {
        //     ...getters.licencesList,
        //     licences: res.data.licences
        //   });
        // } else {
        //   commit(types.LicencesList.SET.ALL, {
        //     ...getters.licencesList,
        //     licences: [
        //       ...getters.licencesList.licences,
        //       ...res.data.licences
        //     ]
        //   });
        // }
        // Setting EOL
        // if (!(res?.data?.length > 0)) {
        //   return EOL_REACHED;
        // }
      }
  
        //const statementOverviewData = await HttpClient.mergeRequests(promises);
      
      //console.log("StatementOverviewData",statementOverviewData);
  
       //commit(types.BelieveStatementList.SET.ALL,  statementOverviewData );
      
       
       
     },  

     async [types.RecoupableList.UPDATE.SINGLE]({ commit, getters, dispatch ,rootGetters }, payload){

      const { kVal, name, value ,item } = payload
      
      let statusUpdateData;
      let newCostSplit;





      if(name=='status'){

        const resData = await recoupableService.changeIgnore(kVal,value);

        commit(types.RecoupableList.SET.ALL, {
          ...getters.recoupableList,
          cost_splits: getters.recoupableList.cost_splits.map(e => {
            if (e.cost_split_id == payload.kVal) {
              return {
                ...e,
                status: resData.data.recoupable_txt,
                hold_flag:value
              };
            }  
            else {
              return e;
            }
          })
        });
      }else if(name=='Account Recoupables'){
        const resData = await recoupableService.createCostSplit(kVal);

        console.log(resData.data.recoupable_txt,'resData.data.recoupable_txt')
        commit(types.RecoupableList.SET.ALL, {
          ...getters.recoupableList,
          cost_splits: getters.recoupableList.cost_splits.map(e => {
            if(e.cost_split_id == kVal){
              //console.log("e",e)
              //console.log("item",payload.item)
              return {
                ...e,
                status:resData.data.recoupable_txt
              }
            }         
            else {
              return e;
            }
          })
        });
      }
      else if(name=='openAdvance'){
        // const resData = await recoupableService.createCostSplit(kVal);

        // console.log(resData.data.recoupable_txt,'resData.data.recoupable_txt')
        commit(types.RecoupableList.SET.ALL, {
          ...getters.recoupableList,
          cost_splits: getters.recoupableList.cost_splits.map(e => {
            if(e.cost_split_id == kVal){
              //console.log("e",e)
              //console.log("item",payload.item)
              return {
                ...e,
                status:value
              }
            }         
            else {
              return e;
            }
          })
        });
      }
      else{
        const resData =await recoupableService.submitCost({...item});
        
        newCostSplit=resData.data.costs.find(e=>e.cost_split_id==kVal);
        
        const cost_group_name=resData.data.cost_groups.find(e=>e.cost_group_id==newCostSplit.cost_group_id).cost_group_name;

        newCostSplit={...newCostSplit ,cost_group_name:cost_group_name};
        
        console.log(resData)
      }  
        
      commit(types.RecoupableList.SET.ALL, {
        ...getters.recoupableList,
        cost_splits: getters.recoupableList.cost_splits.map(e => {
          if(e.cost_split_id == payload.kVal){
            console.log("e",e)
            console.log("item",payload.item)
            return {
              ...e,
              ...newCostSplit
            }
          }         
          else {
            return e;
          }
        })
      });

      //console.log(resData)

     }

}
